import { render } from "./ModalDetailAccident.vue?vue&type=template&id=ee89ec3e&scoped=true"
import script from "./ModalDetailAccident.vue?vue&type=script&lang=js"
export * from "./ModalDetailAccident.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ee89ec3e"

export default script